import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "navbar navbar-light bg-white sticky-top shadow d-print-none" }
const _hoisted_2 = {
  class: "container d-flex justify-content-center",
  id: "navbar-print-view"
}
const _hoisted_3 = { class: "nav nav-pills" }
const _hoisted_4 = { class: "nav-item" }
const _hoisted_5 = {
  href: "#heading-form-general-information",
  class: "nav-link"
}
const _hoisted_6 = { class: "nav-item" }
const _hoisted_7 = {
  href: "#heading-form-statistical-information",
  class: "nav-link"
}
const _hoisted_8 = { class: "nav-item" }
const _hoisted_9 = {
  href: "#heading-form-basic-understanding",
  class: "nav-link"
}
const _hoisted_10 = { class: "nav-item" }
const _hoisted_11 = {
  href: "#heading-form-field-of-actions",
  class: "nav-link"
}
const _hoisted_12 = { class: "nav-item" }
const _hoisted_13 = {
  href: "#heading-form-applications-actions",
  class: "nav-link"
}
const _hoisted_14 = { class: "container json-form" }
const _hoisted_15 = { class: "row justify-content-center" }
const _hoisted_16 = { class: "col-lg-8 pb-7 print" }
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = { class: "lead" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_20 = {
  id: "heading-form-general-information",
  class: "display-6 mb-0 print-page-break-after avoid"
}
const _hoisted_21 = {
  id: "heading-form-statistical-information",
  class: "display-6 border-top border-black-10 pt-7 mt-4 print-page-break-before"
}
const _hoisted_22 = {
  id: "heading-form-basic-understanding",
  class: "display-6 border-top border-black-10 pt-7 mt-4 print-page-break-before"
}
const _hoisted_23 = {
  id: "heading-form-field-of-actions",
  class: "display-6 border-top border-black-10 pt-7 mt-4 print-page-break-before"
}
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = {
  id: "heading-form-applications-actions",
  class: "display-6 border-top border-black-10 pt-7 mt-4 print-page-break-before"
}
const _hoisted_28 = { class: "row" }
const _hoisted_29 = { class: "col-4" }
const _hoisted_30 = { class: "col-8 text-end" }
const _hoisted_31 = {
  key: 1,
  class: "d-flex flex-column justify-content-center align-items-center w-100 vh-100"
}
const _hoisted_32 = {
  class: "spinner-border",
  role: "status"
}
const _hoisted_33 = { class: "visually-hidden" }
const _hoisted_34 = { class: "mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrintFormRenderComponent = _resolveComponent("PrintFormRenderComponent")!
  const _component_ReadOnlyAction = _resolveComponent("ReadOnlyAction")!
  const _component_b_icon_arrow_right = _resolveComponent("b-icon-arrow-right")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_MainFormBottomBar = _resolveComponent("MainFormBottomBar")!

  return (_ctx.hasCurrentApplication)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createElementVNode("nav", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("ul", _hoisted_3, [
              _createElementVNode("li", _hoisted_4, [
                _createElementVNode("a", _hoisted_5, _toDisplayString(_ctx.$t(_ctx.getFormTitle(_ctx.localFormTypes.FormTypeGeneralInformation))), 1)
              ]),
              _createElementVNode("li", _hoisted_6, [
                _createElementVNode("a", _hoisted_7, _toDisplayString(_ctx.$t(_ctx.getFormTitle(_ctx.localFormTypes.FormTypeStatisticalInformation))), 1)
              ]),
              _createElementVNode("li", _hoisted_8, [
                _createElementVNode("a", _hoisted_9, _toDisplayString(_ctx.$t(_ctx.getFormTitle(_ctx.localFormTypes.FormTypeBasicUnderstanding))), 1)
              ]),
              _createElementVNode("li", _hoisted_10, [
                _createElementVNode("a", _hoisted_11, _toDisplayString(_ctx.$t('action_fields.title')), 1)
              ]),
              _createElementVNode("li", _hoisted_12, [
                _createElementVNode("a", _hoisted_13, _toDisplayString(_ctx.$t('meta.pageTitles.actions_overview')), 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("h1", {
                innerHTML: _ctx.$t('text.header', { currentPeriod: _ctx.getCurrentApplicationPeriod(_ctx.currentApplicationPeriod) })
              }, null, 8, _hoisted_17),
              _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.organization.name), 1),
              _hoisted_19,
              _createElementVNode("h2", _hoisted_20, _toDisplayString(_ctx.$t(_ctx.getFormTitle(_ctx.localFormTypes.FormTypeGeneralInformation))), 1),
              _createVNode(_component_PrintFormRenderComponent, {
                "form-object": _ctx.getCorrespondingFormForFormType(_ctx.localFormTypes.FormTypeGeneralInformation, _ctx.applicationForms)
              }, null, 8, ["form-object"]),
              _createElementVNode("h2", _hoisted_21, _toDisplayString(_ctx.$t(_ctx.getFormTitle(_ctx.localFormTypes.FormTypeStatisticalInformation))), 1),
              _createVNode(_component_PrintFormRenderComponent, {
                "form-object": _ctx.getCorrespondingFormForFormType(_ctx.localFormTypes.FormTypeStatisticalInformation, _ctx.applicationForms)
              }, null, 8, ["form-object"]),
              _createElementVNode("h2", _hoisted_22, _toDisplayString(_ctx.$t(_ctx.getFormTitle(_ctx.localFormTypes.FormTypeBasicUnderstanding))), 1),
              _createVNode(_component_PrintFormRenderComponent, {
                "form-object": _ctx.getCorrespondingFormForFormType(_ctx.localFormTypes.FormTypeBasicUnderstanding, _ctx.applicationForms)
              }, null, 8, ["form-object"]),
              _createElementVNode("h2", _hoisted_23, _toDisplayString(_ctx.$t('action_fields.title')), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fieldsOfActions, (fieldOfAction) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: fieldOfAction.id
                }, [
                  _createElementVNode("h2", null, _toDisplayString(_ctx.$t(_ctx.getShortNameOfField(fieldOfAction.field_of_action_type))), 1),
                  _createVNode(_component_PrintFormRenderComponent, { "form-object": fieldOfAction }, null, 8, ["form-object"]),
                  _createElementVNode("h3", null, _toDisplayString(_ctx.$t('text.connected_actions')), 1),
                  (fieldOfAction.actions.length !== 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.applicationActions, (action) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: action.id
                          }, [
                            _createElementVNode("ul", null, [
                              (fieldOfAction.actions.indexOf(action.id) !== -1)
                                ? (_openBlock(), _createElementBlock("li", _hoisted_25, _toDisplayString(action.title), 1))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        _createElementVNode("ul", null, [
                          _createElementVNode("li", null, _toDisplayString(_ctx.$t('text.no_connected_actions')), 1)
                        ])
                      ]))
                ]))
              }), 128)),
              (_ctx.applicationActions.length > 0)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("h2", _hoisted_27, _toDisplayString(_ctx.$t('meta.pageTitles.actions_overview')), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.applicationActions, (action, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: action.id,
                        class: _normalizeClass([index !== _ctx.applicationActions.length - 1 ? 'row print-page-break-after': 'row' ])
                      }, [
                        _createVNode(_component_ReadOnlyAction, {
                          "application-action": action,
                          "fields-of-action": _ctx.fieldsOfActions,
                          "is-print": true
                        }, null, 8, ["application-action", "fields-of-action"])
                      ], 2))
                    }), 128))
                  ], 64))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createVNode(_component_MainFormBottomBar, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openPrintDialog && _ctx.openPrintDialog(...args))),
                  class: "btn btn-secondary"
                }, _toDisplayString(_ctx.$t('text.print_now')), 1)
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createVNode(_component_router_link, {
                  to: { name: 'ApplicationOverview', params: { id: _ctx.applicationId }},
                  class: "btn btn-link"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('links.back_to_overview')) + " ", 1),
                    _createVNode(_component_b_icon_arrow_right, { class: "ms-1" })
                  ]),
                  _: 1
                }, 8, ["to"])
              ])
            ])
          ]),
          _: 1
        })
      ], 64))
    : (_openBlock(), _createElementBlock("div", _hoisted_31, [
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.$t('text.print_view_loading')), 1)
        ]),
        _createElementVNode("h3", _hoisted_34, _toDisplayString(_ctx.$t('text.print_view_loading')), 1)
      ]))
}